<!--
Slightly modified version of:
https://github.com/vuematerial/vue-material/blob/dev/src/components/MdTable/MdTablePagination.vue

MdTablePagination only works inside a table.
This is copy from it's UI with adjusted handling to MPM context.
-->
<template>
  <div
    v-if="paginator && paginator.totalEntries > 0"
    class="md-table-pagination"
  >
    <template v-if="paginator.totalPage >= 5">
      <span class="md-table-pagination-label">Go to Page:</span>

      <md-field>
        <md-select
          v-model="paginator.currentPage"
          md-dense
          md-class="md-pagination-select"
        >
          <md-option
            v-for="page in paginator.totalPage"
            :key="page"
            :value="page"
          >
            {{ page }}
          </md-option>
        </md-select>
      </md-field>
    </template>

    <template v-if="show_per_page">
      <span class="md-table-pagination-label">Rows per page:</span>

      <md-field>
        <md-select
          v-model="perPage"
          md-dense
          md-class="md-pagination-select"
          @md-selected="defaultItemsPerPage(perPage)"
        >
          <md-option value="15">15</md-option>
          <md-option value="50">50</md-option>
          <md-option value="100">100</md-option>
          <md-option value="200">200</md-option>
        </md-select>
      </md-field>
    </template>

    <span>
      {{
        $tc("phrases.paginateLabels", 1, {
          from: paginator.from,
          to: paginator.to,
          total: paginator.totalEntries,
        })
      }}
    </span>

    <md-button
      class="md-icon-button md-table-pagination-previous"
      @click="--paginator.currentPage"
      :disabled="paginator.currentPage === 1"
    >
      <md-icon>keyboard_arrow_left</md-icon>
    </md-button>

    <md-button
      class="md-icon-button md-table-pagination-next"
      @click="++paginator.currentPage"
      :disabled="paginator.currentPage === paginator.totalPage"
    >
      <md-icon>keyboard_arrow_right</md-icon>
    </md-button>
  </div>
</template>

<script>
import { Paginator } from "@/Helpers/Paginator.js"
import { notify } from "@/mixins/notify.js"
import { EventBus } from "@/shared/eventbus.js"
export default {
  name: "Paginate",
  mixins: [notify],
  props: {
    paginatorReference: Paginator,
    callback: {},
    subscriber: String,
    route_name: String,
    show_per_page: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
      paginator: null,
      term: {},
      perPage: 15,
      lastLoadedPage: null,
    }
  },
  mounted() {
    //load the first page
    let pageNumber = this.route_name ? this.$route.query.page : 1
    this.term = this.route_name ? this.$route.query : {}
    this.loadPage(pageNumber)
    EventBus.$on("loadPage", this.eventLoadPage)
  },
  beforeDestroy() {
    // the event bus outlives this component; without $off every destroyed
    // Paginate keeps reacting to "loadPage" and fires duplicate requests
    EventBus.$off("loadPage", this.eventLoadPage)
  },
  watch: {
    $route() {
      if (this.route_name) {
        this.term = this.$route.query
        const targetPage = this.paginator?.currentPage || 1
        this.loadPage(targetPage)
      }
    },
    "paginator.currentPage"(newPage) {
      // lastLoadedPage marks response-driven updates: the data for that page
      // is already displayed, so re-fetching (directly or via a route push)
      // would only duplicate the request
      if (!newPage || this.loading || newPage === this.lastLoadedPage) return

      if (this.route_name) {
        this.$router
          .push({
            query: Object.assign({}, this.term, {
              page: newPage,
              per_page: this.paginator.perPage,
            }),
          })
          .catch((error) => {
            if (error.name !== "NavigationDuplicated") {
              throw error
            }
          })
      } else {
        this.loadPage(newPage)
      }
    },
    paginatorReference: {
      handler(newPaginator) {
        this.paginator = newPaginator
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    eventLoadPage(paginator, term = {}) {
      this.term = term
      this.paginator = paginator
      this.loadPage(1)
    },
    defaultItemsPerPage(data) {
      this.paginator.perPage = data
      this.loadPage(this.paginator.currentPage)
    },
    loadPage(pageNumber) {
      if (this.loading) {
        return
      }
      this.loading = true
      this.paginator
        .loadPage(pageNumber, this.term)
        .then((response) => {
          this.loading = false
          this.lastLoadedPage = response.current_page
          EventBus.$emit("pageLoaded", this.subscriber, response.data)
        })
        .catch((error) => {
          this.loading = false
          if (error.response && error.response.status === 403) {
            console.warn(
              `Permission denied for ${this.subscriber}:`,
              error.message,
            )
            // Emit empty data to trigger empty state instead of infinite loading
            EventBus.$emit("pageLoaded", this.subscriber, [])
          } else {
            this.alertNotify(
              "error",
              error.response?.data?.message || error.message,
            )
            // Emit empty data to prevent infinite loading
            EventBus.$emit("pageLoaded", this.subscriber, [])
          }
        })
    },
  },
}
</script>

<style scoped lang="scss">
.md-table-pagination {
  height: 56px;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: flex-end;
  border-top: 0px solid;
  font-size: 12px;

  .md-table-pagination-previous {
    margin-right: 2px;
    margin-left: 18px;
  }

  .md-field {
    width: 48px;
    min-width: 36px;
    margin: -16px 24px 0 32px;

    &:after,
    &:before {
      display: none;
    }

    .md-select-value {
      font-size: 13px;
    }
  }
}

.md-menu-content.md-pagination-select {
  max-width: 82px;
  min-width: 56px;
  margin-top: 5px;
}
</style>
